export const IMPERSONATION_BANNER_TEXT = {
  label: '대행 로그인',
  message: (name: string, type: 'lp' | 'pf') =>
    `${name} (${type === 'lp' ? 'LP' : 'PF'}) 계정으로 접속 중입니다 — 조회 전용, 1시간`,
  end: '대행 종료',
} as const;
